export default __webpack_public_path__ + "static/media/CIEN.8fe0c122.png";